import { render, staticRenderFns } from "./klicFileBox.vue?vue&type=template&id=0ad1ad95&scoped=true"
import script from "./klicFileBox.vue?vue&type=script&lang=js"
export * from "./klicFileBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1ad95",
  null
  
)

export default component.exports